// src/pages/TermsPage.js
import React from 'react';
import ContentManager from '../components/ContentManager';

const TermsPage = () => {
  return <ContentManager pageType="terms" />;
};

export default TermsPage;